module.exports = __webpack_public_path__ + "img/1596859764.029da70e.jpg";